import React from 'react';
import { getBookingPrecision } from '@clubmed/domains-service';
import { ICONS } from 'Components/utils/icon/icons';
import { updateBookingCart } from 'Components/widgets/cart/cart.actions';
import { useAppContext } from 'Context/ReactAppContext';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { formatAmountForLocale } from 'Utils/currency-config-for-locale/currencyConfigForLocale';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  bookingId: string;
  iconLabel: string;
  price: number;
  transfers: Array<CartTransfer>;
  stayIndex: number;
  updateCart: typeof updateBookingCart;
  isCartLocked?: boolean;
};
export const TransfersService = ({
  transfers,
  price,
  bookingId,
  updateCart,
  iconLabel,
  stayIndex,
  isCartLocked = false,
}: Props) => {
  const appContext = useAppContext();
  const { trackClickEvent } = useTrackEvent();

  const removeFromCart = () => {
    trackClickEvent(TRACK_EVENT_NAMES.CLICK_CART, {
      detail_click: 'remove_transfer',
    });
    updateCart({
      id: transfers[0].id,
      bookingId,
      context: appContext,
      action: 'remove',
      serviceName: 'TRANSFER',
      stayIndex,
    });
  };

  return (
    <Capsule className="mt-20" contentClassName="flex gap-10 items-start p-10">
      <Icon className="text-sienna" name={ICONS.TRANSFER} width="2rem" />
      <div className="flex-1">
        <p className="text-12 font-bold text-sienna">{iconLabel}</p>
        <div className="flex justify-between gap-10 text-14">
          {transfers[0].label}
          <div className="flex items-center gap-10">
            {formatAmountForLocale(price, appContext.locale, undefined, {
              precision: getBookingPrecision(appContext.locale),
            })}
            {!isCartLocked && (
              <button className="leaading-0" onClick={removeFromCart} type="button">
                <Icon name={ICONS.CROSS} width="0.8rem" />
              </button>
            )}
          </div>
        </div>
      </div>
    </Capsule>
  );
};
